<app-breadcrumbs></app-breadcrumbs>
<div id="location-table-wrapper">
    <div [cfaLoading]="isLoading">
        <mat-form-field>
            <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
        </mat-form-field>
    </div>
    <table id="location-table" #locationTable mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="storeNumber">
            <th mat-header-cell *matHeaderCellDef> Store Number </th>
            <td class="store-number-cell" [routerLink]="['/health/device']" [queryParams]="{storeNumber:location.number}" mat-cell
                *matCellDef="let location"> {{location.number}} </td>
        </ng-container>
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> Name </th>
            <td mat-cell *matCellDef="let location"> {{location.name}} </td>
        </ng-container>
        <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef> Address </th>
            <td mat-cell *matCellDef="let location"> {{location.address}} </td>
        </ng-container>
        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef> Status </th>
            <td mat-cell *matCellDef="let location"> {{location.status}} </td>
        </ng-container>
        <ng-container matColumnDef="closedDate">
            <th mat-header-cell *matHeaderCellDef> Closed Date </th>
            <td mat-cell *matCellDef="let location"> {{location.closedDate}} </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 30, 50]" showFirstLastButtons></mat-paginator>
</div>